export const headerTableColumns: any = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
      width: "5%",
    },
    _config: {
      type: "checkbox",
      displayInColumn: false,
      value: "id",
      isClickable: "true",
    },
  },
  {
    display_name: "Key",
    key: "key",
    headerStyles: {
      background: "#7593F2",
      width: "45%",
    },
  },
  {
    display_name: "Value",
    key: "value",
    headerStyles: {
      background: "#7593F2",
      width: "45%",
    },
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "5%",
      color: "#fff",
    },
    _config: {
      displayInColumn: false,
      type: "svg",
      value: "../../../../assets/images/table/table-item-edit.svg",
      isClickable: "true",
    },
  },
];

export const headerTableData: any = [
    {
        key:"Header1",
        value:"Value1"
    },
    {
        key:"Header2",
        value:"Value2"
    },
    {
        key:"Header3",
        value:"Value3"
    },
    {
        key:"Header4",
        value:"Value4"
    
    }
]